module.exports = __webpack_public_path__ + "static/img/loader.36c70ba.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.gif
// module id = x4IX
// module chunks = 1